function partsAt(startAtIso, now) {
  var startMs = new Date(startAtIso).getTime()
  var nowMs = now === undefined ? Date.now() : now
  var diffMs = startMs - nowMs
  var isPast = diffMs <= 0
  var totalSeconds = Math.floor(Math.abs(diffMs) / 1000)

  return {
    isPast: isPast,
    totalSeconds: totalSeconds,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60
  }
}

function partsFor(countdownElement, now) {
  var startAtIso = countdownElement.getAttribute("data-countdown-start-at-value")
  return partsAt(startAtIso, now)
}

window.WeddangCountdown = { partsFor: partsFor }
